<link type="text/css" rel="stylesheet" [href]='sanitizer.bypassSecurityTrustResourceUrl(dynamicCSSUrl)'>
<app-loader></app-loader>
<router-outlet></router-outlet>